import { render, staticRenderFns } from "./RefundInfo.vue?vue&type=template&id=3a5c2561&scoped=true"
import script from "./RefundInfo.vue?vue&type=script&lang=js"
export * from "./RefundInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c2561",
  null
  
)

export default component.exports